import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import { useListBox, useListBoxSection, useOption } from '@react-aria/listbox';
import { CircularLoader, Typography } from '../..';
import { useTheme } from '../ThemeProvider/useTheme';
import { listBox, listItem, listSection } from './styles';
export const ListBox = (props) => {
    const ref = useRef(null);
    const { listBoxRef = ref, state, isLoading, footer } = props;
    const { listBoxProps } = useListBox(props, state, listBoxRef);
    return (_jsxs("div", { className: listBox({ loading: isLoading }), children: [_jsx("ul", Object.assign({ className: listSection() }, listBoxProps, { ref: listBoxRef, children: isLoading ? (_jsx(CircularLoader, {})) : ([...state.collection].map((item) => item.type === 'section' ? (_jsx(ListBoxSection, { section: item, state: state }, item.key)) : (_jsx(Option, { item: item, state: state }, item.key)))) })), footer && _jsx("div", { className: "sticky bottom-0 w-full p-nano", children: footer })] }));
};
const ListBoxSection = ({ section, state }) => {
    const theme = useTheme();
    const { itemProps, headingProps, groupProps } = useListBoxSection({
        heading: section.rendered,
        'aria-label': section['aria-label'],
    });
    return (_jsx(_Fragment, { children: _jsxs("li", Object.assign({}, itemProps, { children: [section.rendered && (_jsx(Typography, Object.assign({ variant: "footnote", color: theme.colors.content.placeholder }, headingProps, { ml: 12, mt: 16, mb: 8, children: section.rendered }))), _jsx("ul", Object.assign({ className: listSection() }, groupProps, { children: [...section.childNodes].map((node) => (_jsx(Option, { item: node, state: state }, node.key))) }))] })) }));
};
const Option = ({ item, state }) => {
    const ref = useRef(null);
    const { optionProps, isDisabled, isSelected, isFocused } = useOption({ key: item.key }, state, ref);
    return (_jsx("li", Object.assign({ className: listItem({
            focused: isFocused,
            selected: isSelected,
            disabled: isDisabled,
        }) }, optionProps, { ref: ref, children: item.rendered })));
};
